import * as React from "react"

const SvgHourglass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 20.428h8v-3q0-1.65-1.175-2.825T12 13.428c-1.65 0-2.042.392-2.825 1.175Q8 15.78 8 17.428zm4-9q1.65 0 2.825-1.175Q16 9.079 16 7.43v-3H8v3q0 1.65 1.175 2.825T12 11.43Zm-7 11a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.288h1v-3q0-1.524.713-2.862A5.6 5.6 0 0 1 8.7 12.428a5.57 5.57 0 0 1-1.987-2.137A6 6 0 0 1 6 7.429v-3H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 3.429a.97.97 0 0 1 .287-.713A.97.97 0 0 1 5 2.429h14q.424 0 .712.287.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288h-1v3a6 6 0 0 1-.712 2.862 5.57 5.57 0 0 1-1.988 2.137 5.6 5.6 0 0 1 1.988 2.138A6 6 0 0 1 18 17.428v3h1q.424 0 .712.288t.288.712a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.288H5Z" />
  </svg>
)
export default SvgHourglass
